import React from "react";
import { cn } from "@/lib/utils";

/**
 * Brand logo component — single source of truth for CostControlX visual identity.
 *
 * Variants:
 *   • full        — CX monogram + COSTCONTROLX wordmark (default, used in marketing/auth)
 *   • icon        — CX monogram only (used in compact spaces: navbar, sidebar collapsed)
 *   • horizontal  — same as full but renders inline-style (no centering)
 *
 * Sizes:
 *   • sm  → 24-28px tall
 *   • md  → 36-40px tall  (default)
 *   • lg  → 60-72px tall
 *   • xl  → 96px tall
 */
export default function Logo({
  variant = "full",
  size = "md",
  className = "",
  alt = "CostControlX",
  ...rest
}) {
  const src =
    variant === "icon"
      ? "/assets/branding/costcontrolx-icon.png"
      : "/assets/branding/costcontrolx-logo.png";

  const heightClass = {
    sm: "h-7",
    md: "h-10",
    lg: "h-14",
    xl: "h-24",
  }[size] || "h-10";

  return (
    <img
      src={src}
      alt={alt}
      draggable={false}
      translate="no"
      className={cn(heightClass, "w-auto select-none", className)}
      data-testid="brand-logo"
      {...rest}
    />
  );
}
